/*
Gets the elevation for a list of locations with format as: locations separated by | in latitude, longitude format
Result: A JSON object with a single list of results. Each result contains latitude, longitude and elevation. 
The results are in the same order as the request parameters. Elevation is in meters.
*/

import superagent from 'superagent'

export const getOpenElevationForLocations = (locations, callback) => {
  const locationsString = locations
    .map(loc => {
      return loc.toUrlValue()
    })
    .join('|')

  superagent
    .get(__OPEN_ELEVATION_URI__)
    .query({ locations: locationsString })
    .set('Accept', 'application/json')
    .set('Version', `${__version__}`)
    .end((err, res) => {
      if (err) {
        callback(null, err)
      } else {
        callback(res.body.results, null)
      }
    })
}
